<template>
  <div class="court-dialog-wrapper">
    <CustomDialog
      ref="customDialog"
      :title="_title"
      :subtitle="_subtitle"
      :footerButtons="_buttons"
      :loading="loading"
      @submit="submit()"
      @opened="showForm = true"
      @closed="showForm = false"
    >
      <div>
        <v-form
          v-if="!!showForm"
          v-model="valid"
          ref="form"
          class="mt-4"
          :disabled="loading"
        >
          <v-row no-gutters>
            <v-col cols="12" class="pr-md-2">
              <v-text-field
                v-model="form.name"
                :label="`Nome da ${this.$t('subgroup')}`"
                :disabled="_viewMode"
                :rules="_rules"
                outlined
              />
            </v-col>

            <v-col cols="6" class="pr-2">
              <ItemSelector
                v-model="sections.groups.selected"
                :items="sections.groups.data"
                :loading="loading"
                :placeholder="sections.groups.placeholder"
                :label="sections.groups.label"
                :count="sections.groups.count"
                :disabled="_viewMode"
                :multiple="false"
                :required="true"
                :item-value="'_id'"
                :item-text="'name'"
                @input="handleSelectedGroup"
                @search="handleSearchGroups"
                @paginate="fetchMoreGroups"
              />
            </v-col>

            <v-col cols="6" class="pr-2 mb-4">
              <ItemSelector
                v-model="sections.people.selected"
                :items="sections.people.data"
                :loading="loading"
                :multiple="true"
                :disabled="_viewMode"
                :required="false"
                :item-value="'_id'"
                :item-text="'name'"
                :item-sub-text="'email'"
                :placeholder="sections.people.placeholder"
                :label="sections.people.label"
                :count="sections.people.count"
                @input="handleSelectedPeople"
                @search="handleSearchPeople"
                @paginate="fetchMorePeople"
              />
            </v-col>

            <v-col cols="12" md="12" class="mt-4">
              <v-select
                v-model="form.enableRequesterChat"
                :items="_requesterChatOptions"
                :label="$t('requesterChat.label')"
                :hint="$t('requesterChat.hintSubgroup')"
                :disabled="_viewMode"
                outlined
              />
            </v-col>

            <!-- <v-col cols="12" md="12">
            <v-switch
              v-model="form.enableAudience"
              :label="
                form.enableAudience
                  ? 'Audiências habilitadas'
                  : 'Audiências desabilitadas'
              "
              class="mt-0"
            />
          </v-col> -->

            <!-- <v-col v-if="!_editMode && !_viewMode" cols="12" md="12">
          <v-switch
            v-model="form.createCalendar"
            label="Criar calendário"
            class="mt-0"
          />
        </v-col> -->
          </v-row>
        </v-form>

        <CustomDialog
          ref="confirmDialog"
          title="Confirmação de alteração"
          subtitle="Deseja realmente salvar estas alterações?"
          width="800"
          :footerButtons="_confirmButtons"
          @submit="submitConfirmation(true)"
          @close="submitConfirmation(false)"
        >
          <div>
            <p v-if="addedUsers.length">
              • Adição dos Gestores: {{ addedUsers.join(", ") }}
            </p>

            <p v-if="removedUsers.length">
              • Remoção dos Gestores: {{ removedUsers.join(", ") }}
            </p>
          </div>
        </CustomDialog>
      </div>
    </CustomDialog>

    <loader-hover v-model="loading" />
  </div>
</template>

<script>
import { createCourts, updateCourts } from "@/services/courts";
import { getJurisdictions } from "@/services/jurisdictions";
import { getUsers } from "@/services/users";
import { getPermissionGroups } from "@/services/permissions";
import { handleAlert, processItemSelectorData } from "@/utils";
import { validation } from "@/utils/validators";
import CustomDialog from "@/components/customDialog/CustomDialog.vue";
import ItemSelector from "@/components/itemSelector/ItemSelector.vue";
import { requesterChatOptions } from "@/utils/requesterChat";

export default {
  name: "CourtDialog",

  components: {
    CustomDialog,
    ItemSelector,
  },

  data() {
    return {
      showForm: false,
      mode: "create",
      valid: false,
      loading: false,
      moderatorGroupID: "",
      form: {
        _id: "",
        name: "",
        comarcasIDs: [],
        peopleIDs: [],
        createCalendar: false,
        enableAudience: false,
        enableRequesterChat: null,
      },
      sections: {
        people: {
          label: "Gestores",
          placeholder: "Digite para buscar...",
          loading: true,
          data: [],
          selected: [],
          page: 0,
          count: 0,
        },
        groups: {
          label: this.$t("group"),
          placeholder: `Selecione o ${this.$t("group")}...`,
          loading: true,
          data: [],
          selected: null,
          page: 0,
          count: 0,
        },
      },
      attendants: [],
      addedUsers: [],
      removedUsers: [],
    };
  },

  watch: {
    ["sections.people.selected"]: {
      handler(val) {
        const newIDs = val.map((user) => user._id);
        const originalIDs = this.attendants.map((user) => user._id);

        const added = val.filter((user) => !originalIDs.includes(user._id));
        const removed = this.attendants.filter(
          (user) => !newIDs.includes(user._id)
        );

        this.addedUsers = added.map((user) => user.name || user.email);
        this.removedUsers = removed.map((user) => user.name || user.email);
      },
      deep: true,
    },
  },

  computed: {
    _requesterChatOptions() {
      return requesterChatOptions({
        inherit: this.$t("requesterChat.inheritFromSubgroup"),
        allow: this.$t("requesterChat.allow"),
        block: this.$t("requesterChat.block"),
      });
    },

    _viewMode() {
      return this.mode === "view";
    },

    _editMode() {
      return this.mode === "edit";
    },

    _title() {
      if (this._viewMode) return `Visualizar ${this.$t("subgroup")}`;
      else if (this._editMode) return `Editar ${this.$t("subgroup")}`;

      return `Adicionar ${this.$t("subgroup")}`;
    },

    _subtitle() {
      if (this._viewMode) return "";
      if (this._editMode)
        return `Preencha os campos abaixo para editar ${this.$t("subgroup")}`;

      return `Preencha os campos abaixo para cadastrar ${this.$t("subgroup")}`;
    },

    _buttons() {
      if (this._viewMode)
        return [
          {
            label: "Fechar",
            color: "primary",
            action: "close",
          },
        ];

      return [
        {
          label: "Cancelar",
          color: "secondary",
          action: "close",
        },
        {
          label: "Finalizar",
          color: "primary",
          action: "submit",
        },
      ];
    },

    _confirmButtons() {
      return [
        {
          label: "Cancelar",
          color: "secondary",
          action: "close",
        },
        {
          label: "Confirmar",
          color: "primary",
          action: "submit",
        },
      ];
    },

    _rules() {
      return [
        (v) => (!!v && v.length > 0) || "Campo obrigatório",
        (v) => validation(v) || "Informe um valor válido",
      ];
    },
  },

  methods: {
    async submit() {
      if (!this.$refs.form.validate() || this._viewMode) return;

      if (this.addedUsers.length || this.removedUsers.length) {
        this.$refs.confirmDialog.open();
        return;
      }

      this.handleCourt();
    },

    async handleCourt() {
      this.loading = true;

      if (this._editMode) await this.updateCourts();
      else await this.createCourts();

      this.loading = false;
    },

    submitConfirmation(confirm = true) {
      this.$refs.confirmDialog.close();

      if (confirm) this.handleCourt();
    },

    async createCourts() {
      try {
        const params = {
          createCalendar: this.form.createCalendar,
        };

        const payload = {
          name: this.form.name,
          comarcasIDs: this.form.comarcasIDs,
          peopleIDs: this.form.peopleIDs,
          // `null` = não configurado nesta vara; cai para a comarca (ADR-008).
          enableRequesterChat: this.form.enableRequesterChat,
        };

        await createCourts(params, payload);

        this.handleAlert(
          `${this.$t("subgroup")} criada com sucesso`,
          "success"
        );
        this.$emit("success");

        this.closeDialog();
      } catch (error) {
        this.handleAlert(error.data.message, "error");
      }
    },

    async updateCourts() {
      try {
        const payload = {
          name: this.form.name,
          comarcasIDs: this.form.comarcasIDs,
          peopleIDs: this.form.peopleIDs,
          enableAudience: this.form.enableAudience,
          enableRequesterChat: this.form.enableRequesterChat,
        };
        await updateCourts(this.form._id, payload);

        this.handleAlert(
          `${this.$t("subgroup")} editada com sucesso`,
          "success"
        );
        this.$emit("success");

        this.closeDialog();
      } catch (error) {
        this.handleAlert(error.data.message, "error");
      }
    },

    async openDialog(data, mode) {
      this.resetForm();

      this.mode = mode || "create";
      this.loading = true;

      if (data) {
        const people = data?.people?.map((el) => ({
          _id: el._id,
          name: el.name,
          email: el.email,
        }));

        this.attendants = people;

        this.sections.people.page = 0;
        this.sections.people.count = 0;
        this.sections.people.loading = false;
        this.sections.people.data = JSON.parse(JSON.stringify(people));
        this.sections.people.selected = JSON.parse(JSON.stringify(people));

        this.sections.groups.page = 0;
        this.sections.groups.count = 0;
        this.sections.groups.loading = false;

        const [group] = data.comarcas || [];
        this.sections.groups.data = [];
        if (group?._id) {
          this.sections.groups.data.push({
            _id: group._id,
            name: group.name,
          });
        }

        this.sections.groups.selected = null;
        if (group?._id) {
          this.sections.groups.selected = {
            _id: group._id,
            name: group.name,
          };
        }

        this.form = {
          _id: data._id,
          name: data.name,
          comarcasIDs: data?.comarcas?.map((el) => el._id),
          peopleIDs: (data?.people || []).map((el) => el._id),
          enableAudience: data.enableAudience,
          enableRequesterChat: data.enableRequesterChat ?? null,
        };
      }

      await this.getPermissionGroups();
      await Promise.all([this.handleFetchGroups(), this.handleFetchPeople()]);

      this.$refs.customDialog.open();
      this.loading = false;
    },

    closeDialog() {
      this.resetForm();
      this.$refs.customDialog.close();
    },

    async getPermissionGroups() {
      if (!this.$can("attendances")) return;

      try {
        const payload = {
          module: "attendances",
          type: "role",
        };

        const { data } = await getPermissionGroups(payload);

        this.moderatorGroupID =
          data.find((el) => el.role === "moderator")?._id || "";
      } catch (error) {
        this.handleAlert(error.data.message, "error");
      }
    },

    resetForm() {
      this.loading = false;
      this.form._id = "";
      this.form.name = "";
      this.form.peopleIDs = [];
      this.form.comarcasIDs = [];
      this.form.createCalendar = false;
      this.form.enableAudience = false;
      this.form.enableRequesterChat = null;

      this.sections.groups.selected = null;
      this.sections.people.selected = [];

      this.addedUsers = [];
      this.removedUsers = [];
      this.attendants = [];

      if (this.$refs.form) this.$refs.form.resetValidation();
    },

    async handleFetchGroups(search = "") {
      this.sections.groups.loading = true;

      const payload = {
        sortBy: "name",
        sortOrder: "asc",
        limit: 10,
        offset: this.sections.groups.page * 10,
        ...(!!search?.length && { search }),
        // ...(!!this.sections.groups.selected && {
        //   nin: [this.sections.groups.selected._id], // Busca com exclusão das selecionadas (nin = not in)
        // }),
      };
      const {
        data,
        headers: { "x-count": count },
      } = await getJurisdictions(payload);

      this.processItemSelectorData(this.sections.groups, data, {
        override: false,
      });

      this.sections.groups.count = Number(count);
      this.sections.groups.loading = false;
    },

    handleSelectedGroup(selected) {
      this.sections.groups.selected = selected;
      this.form.comarcasIDs = selected?._id ? [selected._id] : [];
    },

    async handleSearchGroups(search = "") {
      this.sections.groups.page = 0;
      this.sections.groups.count = 0;
      this.sections.groups.data = [];

      this.handleFetchGroups(search);
    },

    async fetchMoreGroups(search = "") {
      this.sections.groups.page++;
      this.handleFetchGroups(search);
    },

    async handleFetchPeople(search = "") {
      if (!this.moderatorGroupID) return;

      this.sections.people.loading = true;

      const payload = {
        sortBy: "email",
        sortOrder: "asc",
        limit: 10,
        offset: this.sections.people.page * 10,
        permissionGroupIDs: [this.moderatorGroupID],
        ...(!!search?.length && { search }),
        ...(!!this.sections.people.selected && {
          nin: [this.sections.people.selected._id], // Busca com exclusão das selecionadas (nin = not in)
        }),
      };
      const {
        data,
        headers: { "x-count": count },
      } = await getUsers(payload);

      if (search) {
        this.sections.people.data = [
          ...this.sections.people.selected,
          ...data.map((person) => ({
            _id: person._id,
            name: person.name || person.email,
            email: person.email,
          })),
          ...this.sections.people.data,
        ];
      } else {
        this.sections.people.data = [
          ...this.sections.people.selected,
          ...this.sections.people.data,
          ...data.map((person) => ({
            _id: person._id,
            name: person.name || person.email,
            email: person.email,
          })),
        ];
      }

      this.sections.people.count = Number(count);
      this.sections.people.loading = false;
    },

    handleSelectedPeople(selected) {
      this.sections.people.selected = selected;
      this.form.peopleIDs = selected?.map((el) => el._id) || [];
    },

    async handleSearchPeople(search = "") {
      this.sections.people.page = 0;
      this.sections.people.count = 0;
      this.sections.people.data = [];

      this.handleFetchPeople(search);
    },

    async fetchMorePeople(search = "") {
      this.sections.people.page++;
      this.handleFetchPeople(search);
    },

    processItemSelectorData,
    handleAlert,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
